import { t } from '@/lib/i18n'

/** "Skip to content" link, visible on keyboard focus (UI.md section 10). */
export function SkipLink() {
  return (
    <a
      href="#main-content"
      className="sr-only z-[60] rounded-control bg-primary px-4 py-2 text-btn text-on-primary focus:not-sr-only focus:fixed focus:left-4 focus:top-3 focus:shadow-pop"
    >
      {t('Skip to content')}
    </a>
  )
}
